// CB:BEGIN settings-checkbox-component
import React from 'react';

interface SettingsCheckboxProps {
  id: string;
  checked: boolean;
  onCheckedChange: (next: boolean) => void;
  label: string;
  description?: string;
  disabled?: boolean;
  className?: string;
  name?: string;
  testId?: string;
  danger?: boolean;
}

export function SettingsCheckbox({
  id,
  checked,
  onCheckedChange,
  label,
  description,
  disabled = false,
  className = '',
  name,
  testId,
  danger = false,
}: SettingsCheckboxProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onCheckedChange(e.target.checked);
  };

  return (
    <label
      htmlFor={id}
      className={`flex items-start gap-3 cursor-pointer select-none ${disabled ? 'cursor-not-allowed opacity-50' : ''} ${className}`}
      data-testid={testId ? `${testId}-label` : undefined}
    >
      <input
        type="checkbox"
        id={id}
        name={name}
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        className="corebids-settings-checkbox rounded border border-gray-300 bg-white text-gray-900 focus:ring-0 focus:ring-offset-0 disabled:opacity-50 disabled:cursor-not-allowed accent-gray-900 cursor-pointer"
        style={{
          width: '16px',
          height: '16px',
          marginTop: '2px',
          accentColor: '#111827', // gray-900 for black checkmark
        }}
        data-testid={testId ?? id}
        aria-describedby={description ? `${id}-description` : undefined}
      />
      <div className="flex-1">
        <div className={`font-medium text-sm ${danger ? 'text-red-700' : 'text-gray-900'}`}>
          {label}
        </div>
        {description && (
          <div
            id={`${id}-description`}
            className="text-xs text-gray-500 mt-1 leading-relaxed"
          >
            {description}
          </div>
        )}
      </div>
    </label>
  );
}
// CB:END settings-checkbox-component

